import { useUserContext } from "./useUserContext";
import { createAxiosApi } from "../Helpers/axiosApiHelper";
import {
	useState,
	useEffect
} from "react";

export function useUnitEquivalentService(config) {
	const user = useUserContext(config);
	const [service, setService] = useState(() => {
		return createUnitEquivalentService(user, config);
	});

	useEffect(() => {
		setService(createUnitEquivalentService(user, config));
	}, [user.authToken]); // eslint-disable-line react-hooks/exhaustive-deps

	return service;
}

function createUnitEquivalentService(user, config) {
	const api = createAxiosApi("", user, config);

	function getAll(handleResponse, handleError) {
		api.get("UnitEquivalents/")
			.then(handleResponse)
			.catch(handleError);
	}

	function getById(unitEquivalentId, handleResponse, handleError) {
		api.get(`UnitEquivalents/${unitEquivalentId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	function create(unitEquivalent, handleResponse, handleError) {
		api.post("UnitEquivalents/", unitEquivalent)
			.then(handleResponse)
			.catch(handleError);
	}

	function update(unitEquivalentId, unitEquivalent, handleResponse, handleError) {
		api.put(`UnitEquivalents/${unitEquivalentId}`, unitEquivalent)
			.then(handleResponse)
			.catch(handleError);
	}

	function deleteItem(unitEquivalentId, handleResponse, handleError) {
		api.delete(`UnitEquivalents/${unitEquivalentId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	function importItems(unitEquivalents, handleResponse, handleError) {
		api.post("UnitEquivalents/import", unitEquivalents)
			.then(handleResponse)
			.catch(handleError);
	}

	return {
		getAll,
		getById,
		create,
		update,
		deleteItem,
		importItems
	};
}
